window.$nature_protection_result = [];
window.$nature_protection_didUpdateChange = true;
window.$nature_protection_treeChangeStatus = false;
window.$nature_protection_treeList = [];
window.$nature_protection_page_number = 1;
window.$nature_protection_newInsertId = [];
window.$nature_protection_Glist = [];
window.$nature_protection_content = [];
window.$nature_protection_search_filter_wetenschappelijkenaam = [];
window.$nature_protection_search_filter_nederlandsenaam = [];
window.$nature_protection_search_filter_wet = [];
window.$nature_protection_search_filter_ovg = [];
window.$nature_protection_search_filter_naamperiode = [];
window.$nature_protection_search_filter_soort = [];
window.$nature_protection_selectedRow = [];
window.$nature_protection_gvv = 1;
window.$nature_protection_filterMaatregelenIsActive = [];
window.$nature_protection_filterPlannigIsActive = [];
window.$nature_protection_filterContent = [];
window.$nature_protection_filterClickStatus = false;
window.$nature_protection_scroll_change = false;
window.$nature_protection_columnList = [];
window.$nature_protection_selectedIds = null;
window.$nature_protection_token = null;
window.$nature_protection_table_total_row_count = 0;
window.$nature_protection_columnListPure = null;
window.$nature_protection_treeListPure = [];
window.$nature_protection_refresh = function (){};
window.$nature_protection_lastUsedTableFilter = {
  content: [],
  definitions: [],
};
window.$template_identification = "c71e9e59-07e8-4de2-960f-be5a0d5f548a"
window.$nature_protection_actions = [
  {
    id: "787cf96e-0c70-4b20-8e4c-2ac70224b82c",
    text: "Beheereenheid toevoegen",
    class: "locate",
    modal: "beheereenheid_toevoegen",
  },
  {
    id: "1",
    text: "Bulk import",
    class: "locate",
    modal: "bulk-import",
  },
];
window.$nature_protection_column_order_post_model = {
  client_identification: "",
  code: "",
  data: {
    table_sorting: [
      {
        name: "catalog>nature-protection",
        column_list: [
          "checkbox",
          "active",
          "Wetenschappelijke naam",
          "Nederlandse naam",
          "Wet",
          "Overige statussen",
          "Naam periode",
          "Soort",
          "Begin periode",
          "Einde periode",
        ],
      },
    ],
  },
};
